import Splide from '@splidejs/splide';
import Helper from "../Helper";

/**
 * This class represents Splide gallery on the page.
 * Slider Gallery means, that it will just allow sliding
 */
export default class HomeGallery {

  /**
   * Initialize gallery.
   *
   * @param {String} galleryName
   */
    constructor(galleryName)
    {
        this.gallery = $('[data-home-gallery="' + galleryName + '"]');
        this.gallerySlider = this.gallery.find('[data-gallery-slider]');
        this.height = Helper.isMobileOrLower() ? 530 : 600;
        this.pagination = this.gallery.find('[data-gallery-pagination]');

        this.slider = undefined;
        this.sliderOptions = {
            lazyLoad: 'nearby',
            type: 'loop',
            waitForTransition: true,
            height: this.height,
            autoplay: true,
            arrows: false,
            interval: 8000,
            pauseOnHover: false,
            pauseOnFocus: false,
            pagination: false,
            drag: Helper.isMobileOrLower(),
            keyboard: 'global',
            slideFocus: true
        };

        $(window).resize(function () {
            $('.translate-3d-wrapper').css({
                'max-width': $(window).width() + 'px'
            });
        });

        $('.translate-3d-wrapper').css({
            'max-width': $(window).width() + 'px'
        });
    }

    /**
    * Function that inits the gallery
    */
    initGallery()
    {
        if (this.slider === undefined && this.gallery.find('img').length > 0) {
            this.slider = new Splide('#' + this.gallerySlider.attr('id'), this.sliderOptions);

            // on move change the pagination active classes
            this.slider.on('move', (newIndex, prevIndex) => {
                let oldImagePagination = this.pagination.find('[data-pagination="' + prevIndex + '"]').first();
                let newImagePagination = this.pagination.find('[data-pagination="' + newIndex + '"]').first();

                $(oldImagePagination).removeClass('is-active');
                $(oldImagePagination).find('button').removeClass('is-active');
                $(newImagePagination).addClass('is-active');
                $(newImagePagination).find('button').addClass('is-active');
            });

            // on start add active class -> must be via JS because of animation
            this.slider.on('autoplay:play', () => {
                let firstImagePagination = this.pagination.find('[data-pagination="0"]').first();

                $(firstImagePagination).addClass('is-active');
                $(firstImagePagination).find('button').addClass('is-active');
            });

            this.slider.mount();

            this.paginationInit();
        }
    }

    /**
     * Function that inits pagination buttons
     */
    paginationInit()
    {
        this.pagination.find('[data-pagination]').each((index, element) => {
            $(element).on('click', () => {
                this.slider.go($(element).data('pagination'));
            })
        });
    }
}
